var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptySchoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart-fill 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M60.0032 22.6448C65.716 17.5308 73.1706 14.7992 80.8351 15.0112C88.4996 15.2232 95.7918 18.3628 101.213 23.7848C106.63 29.2008 109.77 36.4835 109.989 44.1403C110.209 51.797 107.491 59.2476 102.393 64.9648L59.9932 107.425L17.6032 64.9648C12.4994 59.2446 9.77917 51.7876 10.0008 44.1247C10.2225 36.4619 13.3693 29.1746 18.7951 23.759C24.221 18.3434 31.5142 15.2104 39.1775 15.0032C46.8408 14.796 54.2926 17.5303 60.0032 22.6448Z",
    fill: "#FF7A2C",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 85",
    cx: 87,
    cy: 38,
    r: 8,
    fill: "#FEFEFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySchoolIcon);
export default __webpack_public_path__ + "static/media/emptySchool_icon.0312357901127ac2f72e4df564e5a32f.svg";
export { ForwardRef as ReactComponent };